import { Bookmark, BookmarkCheck } from "lucide-react"
import { useBookmarkIds, useToggleBookmark } from "@/hooks/useBookmarks"
import { cn } from "@/lib/utils"

export function BookmarkButton({
  paperId,
  size = "sm",
  className,
}: {
  paperId: string
  size?: "sm" | "md"
  className?: string
}) {
  const { data: ids } = useBookmarkIds()
  const toggle = useToggleBookmark()
  const bookmarked = !!ids?.includes(paperId)
  const iconCls = size === "md" ? "h-5 w-5" : "h-4 w-4"
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggle.mutate({ paperId, bookmarked })
      }}
      disabled={toggle.isPending}
      title={bookmarked ? "북마크 해제" : "북마크"}
      className={cn(
        "inline-flex items-center justify-center rounded-md p-1 transition-colors",
        bookmarked
          ? "text-primary hover:bg-primary/10"
          : "text-muted-foreground hover:bg-secondary hover:text-foreground",
        className,
      )}
    >
      {bookmarked ? (
        <BookmarkCheck className={iconCls} />
      ) : (
        <Bookmark className={iconCls} />
      )}
    </button>
  )
}
